import React, { useState, useEffect } from "react";

const TextArea = React.forwardRef((props, ref) => {
    const {
        type, // destructure of the rest only (this props is not consumed by the component)
        name,
        id,
        placeholder,
        getValue,
        value,
        rows,
        error,
        displayError,
        onChange,
        reactourTextArea,
        resetValue,
        ...rest
    } = props;
    const [currentValue, setCurrentValue] = useState(value);

    useEffect(() => {
        if (value !== currentValue) {
            setCurrentValue(value);
        }
    }, [currentValue, value]);

    return (
        <div
            className="ek-chat__writer--textareaWrapper"
            data-tut={reactourTextArea}
        >
            <textarea
                ref={ref}
                rows={rows}
                name={name}
                {...(id && { id })}
                placeholder={placeholder}
                value={currentValue}
                onChange={(e) => {
                    setCurrentValue(e.target.value);
                    onChange(e);
                }}
                {...rest}
            />
        </div>
    );
});

export default TextArea;
